import { type SupportedLocale, SUPPORTED_LOCALES } from '@reward-platform/shared-schemas'

export const DEFAULT_LOCALE: SupportedLocale = 'en-GB'

export const LOCALES = SUPPORTED_LOCALES
